import { render, staticRenderFns } from "./addHkrg.vue?vue&type=template&id=2b22a4df&scoped=true"
import script from "./addHkrg.vue?vue&type=script&lang=js"
export * from "./addHkrg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b22a4df",
  null
  
)

export default component.exports